import { useState } from "react";
import { heroTags, hotList } from "@/mocks/guagua";

function Hero() {
  const [keyword, setKeyword] = useState("");
  const [focused, setFocused] = useState(false);

  const results = keyword.trim()
    ? hotList.filter((item) => item.title.includes(keyword.trim())).slice(0, 4)
    : [];

  const showDropdown = focused && keyword.trim() && results.length > 0;

  return (
    <section
      id="home"
      className="relative flex min-h-[560px] md:min-h-[640px] w-full items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=vibrant%20abstract%20energy%20collage%20of%20trending%20news%2C%20phone%20screens%2C%20pop%20culture%20fragments%20and%20hot%20topic%20badges%2C%20warm%20orange%20amber%20and%20coral%20tones%2C%20cinematic%20lighting%2C%20rich%20texture%2C%20artistic%20editorial%20style%2C%20high%20detail%20without%20any%20text&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="热点事件短视频聚合视觉背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 md:px-6 py-24 md:py-32 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm ring-1 ring-background-50/30">
          <i className="ri-flashlight-fill text-accent-400" aria-hidden="true"></i>
          全网热点 实时聚合 · 今日更新
        </span>

        <h1 className="font-heading mt-6 text-4xl md:text-6xl leading-tight text-background-50 tracking-wide">
          瓜田瓜王
          <span className="text-accent-400"> · </span>
          一网打尽
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base md:text-lg text-background-50/85 leading-relaxed">
          聚合全网热点事件短视频，实时跟进热门瓜与焦点视频，快速围观事件现场，话题视频一网打尽，满足你随时追更的最新动态需求。
        </p>

        <div className="relative mx-auto mt-8 max-w-xl">
          <form
            className="flex items-center gap-2 rounded-full bg-background-50 p-1.5 shadow-lg"
            role="search"
            aria-label="站内搜索"
            onSubmit={(e) => e.preventDefault()}
          >
            <i
              className="ri-search-line ml-3 text-lg text-foreground-500"
              aria-hidden="true"
            ></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onFocus={() => setFocused(true)}
              onBlur={() => setTimeout(() => setFocused(false), 150)}
              placeholder="搜索热点瓜、事件、明星…"
              className="w-full flex-1 bg-transparent py-2 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="submit"
              className="shrink-0 rounded-full bg-primary-500 px-5 py-2 text-sm whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
            >
              搜热点
            </button>
          </form>

          {showDropdown && (
            <div className="absolute left-0 right-0 top-full z-20 mt-2 overflow-hidden rounded-2xl border border-background-200 bg-background-50 text-left shadow-xl">
              {results.map((item) => (
                <a
                  key={item.rank}
                  href="#hot"
                  className="flex items-center gap-3 px-4 py-3 text-sm text-foreground-700 transition-colors hover:bg-primary-100/50"
                >
                  <span className="shrink-0 text-primary-600">#{item.rank}</span>
                  <span className="line-clamp-1 flex-1">{item.title}</span>
                  <span className="shrink-0 rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                    {item.tag}
                  </span>
                </a>
              ))}
            </div>
          )}
        </div>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
          {heroTags.map((tag) => (
            <a
              key={tag}
              href="#category"
              className="rounded-full bg-background-50/15 px-3.5 py-1.5 text-xs md:text-sm text-background-50 ring-1 ring-background-50/25 transition-colors hover:bg-background-50/30"
            >
              #{tag}
            </a>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-2 text-background-50/80 text-sm">
          <a
            href="#hot"
            className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-6 py-3 text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-fire-fill" aria-hidden="true"></i>
            看今日热榜
          </a>
          <a
            href="#video"
            className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-6 py-3 text-background-50 ring-1 ring-background-50/30 transition-colors hover:bg-background-50/25"
          >
            <i className="ri-play-circle-line" aria-hidden="true"></i>
            围观事件现场
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;